import { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";
import logger from "../lib/logger";

const EditModeContext = createContext(null);
const STORAGE_KEY = "aimploy_edit_mode";

export function EditModeProvider({ children }) {
    const [editMode, setEditMode] = useState(() => {
        try {
            return localStorage.getItem(STORAGE_KEY) === "1";
        } catch (err) {
            logger.warn("EditMode storage read failed:", err);
            return false;
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem(STORAGE_KEY, editMode ? "1" : "0");
        } catch (err) {
            logger.warn("EditMode storage write failed:", err);
        }
    }, [editMode]);

    const toggle = useCallback(() => setEditMode((v) => !v), []);
    const value = useMemo(() => ({ editMode, setEditMode, toggle }), [editMode, toggle]);

    return <EditModeContext.Provider value={value}>{children}</EditModeContext.Provider>;
}

export function useEditMode() {
    return useContext(EditModeContext);
}
